import { render, staticRenderFns } from "./ReviewFormModal.vue?vue&type=template&id=1878f5f8&scoped=true&"
import script from "./ReviewFormModal.vue?vue&type=script&lang=js&"
export * from "./ReviewFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878f5f8",
  null
  
)

export default component.exports